import { useState } from 'react'
import { useDispatch } from 'react-redux'
import { useTranslation } from 'react-i18next'
import { Button, Dialog, DialogActions, DialogContent, DialogTitle } from '@mui/material'

import { addSavedSearch, getSavedSearches } from 'store/actions/savedSearches'

const SaveMySearchModal = ({ showModal, modalTitle, onDismiss }) => {
  const { i18n } = useTranslation()
  const t = i18n.getResourceBundle(i18n.language)
  const dispatch = useDispatch()

  const [savedSearchName, setSavedSearchName] = useState('')

  const handleSaveSearch = () => {
    dispatch(addSavedSearch({ name: savedSearchName, search_url: window.location.href }))
    dispatch(getSavedSearches())
    onDismiss()
  }

  const handleUpdateSavedSearchName = e => {
    setSavedSearchName(e.target.value)
  }

  return (
    <Dialog className="Save-search" open={showModal} onClose={onDismiss}>
      <DialogTitle>{modalTitle}</DialogTitle>
      <DialogContent>
        <div>
          {t.search.saveSearch.title}

          <div>
            <input
              placeholder={t.search.saveSearch.placeholder}
              className="Save-search--input"
              type="text"
              maxLength={50}
              minLength={2}
              value={savedSearchName}
              onChange={handleUpdateSavedSearchName}
            />
          </div>
        </div>
      </DialogContent>
      <DialogActions>
        <Button
          className="main-button"
          disabled={false}
          onClick={handleSaveSearch}
          color="primary"
          variant="text"
        >
          {t.search.save}
        </Button>
        <Button
          className="Material-cards__expanded-state add"
          onClick={onDismiss}
          color="primary"
          variant="text"
        >
          {t.global.close}
        </Button>
      </DialogActions>
    </Dialog>
  )
}

export default SaveMySearchModal
